<template>
  <div>
    <div class="row beast-member-add" v-if="isLoggedIn">
      <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
      <div class="col-7">
        <div class="form-group">
          <label>User</label>
          <input type="text" class="form-control" v-model="member.username"/>
        </div>
      </div>
      <div class="col-3">
        <div class="form-group">
          <label>Role</label>
          <select class="form-control" v-model="member.role">
            <option v-for="(value, key) in roles"
                    :value="key"
                    :key="key">
              {{value}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group text-center">
          <label>&nbsp;</label>
          <div class="btn-group btn-block">
            <button class="btn btn-success" @click="storeData">
              <font-awesome-icon :icon="save"/>
            </button>
            <button class="btn btn-danger" @click="clearData">
              <font-awesome-icon :icon="times"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-striped table-borderless beast-table">
      <thead>
      <tr>
        <th class="beast-table-name">Name</th>
        <th class="beast-table-role">Role</th>
        <th class="beast-table-edit" v-if="isLoggedIn">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="member.fullName"
          v-for="member in members.data">
        <td class="beast-table-name">
          <router-link :to="`/profile/${member.username}`">{{member.fullName}} ({{member.username}})</router-link>
        </td>
        <td class="beast-table-role">
          {{member.translatedRole}}
        </td>
        <td class="beast-table-edit" v-if="isLoggedIn">
          <div class="btn-group" v-if="member.role !== 'OWNER'">
            <button class="btn btn-link text-warning" @click="modify(member.username, member.role)">
              <font-awesome-icon :icon="edit"/>
            </button>
            <button class="btn btn-link text-danger" @click="remove(member.username)">
              <font-awesome-icon :icon="times"/>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <pagination :current="members.page"
                :pages="members.pages"
                @pageChange="readData"/>
  </div>
</template>


<style scoped lang="scss">
  .beast-table {
    .beast-table-name {
      width: 70%;
      vertical-align: middle;
      a {
        color: $beast-dark-gray;

        &:hover {
          color: $beast-green
        }
      }
    }
    .beast-table-role {
      width: 30%;
      vertical-align: middle;
    }
  }

  .beast-member-add {
    label {
      font-weight: bold;
    }
  }
</style>

<script>
import { faSave, faEdit, faTimes, faPlus } from "@fortawesome/free-solid-svg-icons";

import Pagination from "../../components/utils/Pagination.vue";

export default {
  components: { Pagination },
  props: {
    org: Object
  },
  watch: {
    async org() {
      await this.readData();
    }
  },
  computed: {
    apiURL() {
      return `/organizations/${this.org.slug}/members`;
    },
    isLoggedIn() {
      return this.$auth.check() && this.org && this.org.allowedToEdit;
    },
    edit() {
      return faEdit;
    },
    times() {
      return faTimes;
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      members: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
      roles: [],
      member: {
        username: "",
        role: "USER",
        new: true,
      },
      save: faPlus
    };
  },
  methods: {
    async readData(page = 1) {
      const queryParams = {
        params: {
          size: 10,
          page
        }
      };

      const response = await this.axios.get(this.apiURL, queryParams);
      this.members = response.data;

      if (this.$auth.check()) {
        const responseRoles = await this.axios.get(`${this.apiURL}/roles`);
        this.roles = responseRoles.data;
        delete this.roles.OWNER;
      }
    },
    modify(username, role) {
      this.member.username = username;
      this.member.role = role;
      this.member.new = false;
      this.save = faSave;
    },
    async remove(username) {
      try {
        await this.$dialog.confirm("Are you sure you want to delete the user?", {
          okText: "Yes",
          cancelText: "Cancel"
        });
        await this.axios.delete(this.apiURL, {
          data: {
            username
          }
        });
        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        this.clearData();
        await this.$parent.readData();
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    clearData() {
      this.member.username = "";
      this.member.role = "USER";
      this.member.new = true;
      this.save = faPlus;
    },
    async storeData() {
      const body = Object.assign({}, this.member);
      delete body.new;

      try {
        await (this.member.new
          ? this.axios.post(this.apiURL, body)
          : this.axios.put(this.apiURL, body));

        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        this.clearData();
        await this.$parent.readData();
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    if (this.org.slug !== "") {
      await this.readData();
    }
  }
};
</script>
